/* eslint semi:0 */
import { connect } from 'react-redux'
import React, { Component } from 'react'
import { getCurrentIsoStringDate } from '../../jsCore/utils/date'
import { t } from '../../jsCore/providers/i18nProvider/i18nProvider'
import reduxMount from '../../jsCore/utils/reduxMounter'
import TvChannelSelection from './TvChannelSelection'
import { MOUNT_POINTS } from '../../jsCore/config/preRenderedSelectorsConfig'
import { isSupportedForDomain } from '../../jsCore/application/pageDataObject'
import { getNoEndpointsErrorMessage } from '../../jsCore/application/sagas/fetchSaga'
import { changeSelectedChannelName, fetchData } from './tvScheduleActions'
import tvChannelSelectionReducer, { transformTvChannelsData } from './tvChannelSelectionReducer'
import { defaultChannels } from './tvScheduleEmptyDay'
import { mapStateToProps } from '../tv_schedule_container/tvScheduleContainer'

export const TV_SCHEDULE_COMPONENT_STATE_KEY = 'tvScheduleComponent'
const TV_SCHEDULE_CHANNEL_SELECTION_COMPONENT_NAME = 'TvScheduleChannelSelection'

const blockName = 'tv-channel-selection'

function TvScheduleWatchMoreButton(props) {
  const url =
    defaultChannels[props.currentChannelName] &&
    defaultChannels[props.currentChannelName].channelUrl
  const className = `${props.blockName}__button-watch-more`
  return (
    <a className={className} target="_blank" href={url}>
      {t('pages.tv_programming.watch_now')}
    </a>
  )
}
export class TvScheduleChannelSelection extends Component {
  componentWillMount() {
    const { props: { IS_ENTRY_POINT_MISSING, IS_INITIALIZED, IS_LOADING, dispatch } } = this
    if (IS_ENTRY_POINT_MISSING) {
      return getNoEndpointsErrorMessage(this)
    }
    if (!IS_INITIALIZED) {
      return dispatch(fetchData(transformTvChannelsData, getCurrentIsoStringDate()))
    }
    return this
  }

  onChangeSelection(e) {
    const { value: selectedChannelName } = e.target
    this.props.dispatch(changeSelectedChannelName(selectedChannelName))
  }

  render() {
    const { onChangeSelection, props: { currentChannelName, channelNames } } = this
    const tvChannelSelectionProps = {
      selected: currentChannelName,
      entityName: 'tv-channel',
      available: channelNames,
      onChange: onChangeSelection.bind(this),
      blockName,
    }
    return (
      <div className={`${blockName}__container`}>
        <TvChannelSelection {...tvChannelSelectionProps} />
        <TvScheduleWatchMoreButton blockName={blockName} currentChannelName={currentChannelName} />
      </div>
    )
  }
}

const TvScheduleChannelSelectionContainer = {
  name: TV_SCHEDULE_CHANNEL_SELECTION_COMPONENT_NAME,
  stateKey: TV_SCHEDULE_COMPONENT_STATE_KEY,
  component: connect(mapStateToProps)(TvScheduleChannelSelection),
  reducer: tvChannelSelectionReducer,
}

function mountTvScheduleChannelSelection() {
  return reduxMount({
    [MOUNT_POINTS.TV_SCHEDULE_CHANNEL_SELECTION]: TvScheduleChannelSelectionContainer,
  })
}

const TV_SCHEDULE_FEATURE_ID = 'TvSchedule'

export default function initTvChannelSelection() {
  const shouldMountTvScheduleChannelSelection = isSupportedForDomain(TV_SCHEDULE_FEATURE_ID)
  if (shouldMountTvScheduleChannelSelection) {
    mountTvScheduleChannelSelection()
  }
  return shouldMountTvScheduleChannelSelection
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/tv_channel_selection/tvChannelSelectionContainer.js